import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "../views/desktop/home.desktop.vue";
// import _detect from "@/utils/ua";
Vue.use(VueRouter);

// const { ipad, phone } = _detect.os;

// let os = "desktop";
// if (ipad) os = "desktop";
// if (phone) os = "desktop";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home/home.desktop.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/website",
  routes,
});

// const ua = window.navigator.userAgent;
// let isMobile = false;

// if (ua.indexOf("iPhone") >= 0) isMobile = true;
// if (ua.indexOf("Android") >= 0) isMobile = true;
// if (ua.indexOf("iPad") >= 0) isMobile = true;

export default router;
